import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import reducers from '../reducers'
import thunk from 'redux-thunk'
import { isDevelopment } from '../../helpers/env'

const store = createStore(
  reducers,
  isDevelopment
    ? composeWithDevTools(applyMiddleware(thunk))
    : applyMiddleware(thunk)
)

export type RootState = ReturnType<typeof reducers>
export default store
